/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchCatalog = {
    /**
     * Execute after init of component
     */
    initCatalog() {
        this.handlePageChange();
        this.setCurrentPage();

        // Watch for changes in selected facets
        Alpine.effect(() => this.handleSelectedFacetsChange());

        this.getProducts("initial", this.pagesCurrent);
    },
    /**
     * Use selected facets to update URL parameters
     */
    handleSelectedFacetsChange() {
        const currentParams = new Set(this.selectedFacets.map(facet => facet.attribute));

        // Add or update URL parameters for selected facets
        this.selectedFacets.forEach(facet => {
            this.addOrUpdateUrlParam(facet.attribute, facet.option);
        });

        // Remove URL parameters for deselected facets
        Array.from(this.urlParams.keys()).forEach(key => {
            if (!currentParams.has(key) && this.excludedUrlParams.indexOf(key) === -1) {
                this.removeUrlParam(key);
            }
        });
    }
}

export default liveSearchCatalog;
